import { useState, useEffect, useRef, useLayoutEffect } from "react";
import { getAccountType, } from "../../redux/actions/accounttype.action";
import { Row, Col, Form, Input, Checkbox, Divider, Select, Button } from "antd";

import PageHeader from "../../components/PageHeader/PageHeader";
import { useSelector, useDispatch } from "react-redux";

import "../Style/style.css";
import { TabTitle } from "../../utils/GeneralFunction";
import { getItemTransferFormData } from "../../redux/actions/itemTransfer.action";
import { createAutoTransfer } from "../../redux/actions/createTransfer.action";
import notification from "../../utils/notification";
const { Option } = Select;

const rateList = ["AVERAGE", "CURRENT", "HISTORICAL"];
const CreateTransfer = ({ token }) => {
  TabTitle("Create Transfer")
  const dispatch = useDispatch();
  const { userRights, accounttype, itemTransferFormData, autoTransfer } = useSelector((state) => state);

  const [form] = Form.useForm();

  useEffect(() => {
    dispatch(getItemTransferFormData(token));
  }, []);







  const formSave = async () => {
    await form.validateFields().then((values) => {
      dispatch(createAutoTransfer(token, values)).then((res) => {
        if (res.type === "CREATE_TRANSFER_SUCCESS") {
          if (res?.payload?.already_created) {
            notification("success", "Transfer already created with the same details. Ref no: " + res?.payload?.reference_no);
          } else {
            notification("success", "Transfer created successfully");
          }
          form.setFieldsValue({
            reference_no: null,
            asn_no: null,
            to_location: null
          })
        } else if (res.type === "CREATE_TRANSFER_ERROR") {
          notification("error", "Error creating transfer", res?.payload?.data?.message);
        }
      })

    });
  };


  return (
    <div className="styleContainer">
      <div className="styleBody h-100">
        <PageHeader
          title={"Create Transfer"}

        />

        <div className="bodyStyle">

          <div className="styleContent">
            <Row className="tables-main-row-new">

              <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                <div className="styleForm">

                  <Form onFinish={formSave} form={form}>
                    <div className="customRow styleFormUpper d-flex flex-row flex-wrap justify-content-start">
                      <div className="customCols slc m-0 width400">
                        <Form.Item
                          label="Reference no"
                          name="reference_no"
                          labelCol={{ span: 10 }}
                          wrapperCol={{ span: 14 }}
                          rules={[
                            {
                              required: true,
                              message: "Reference no is required",
                            },
                          ]}
                        >
                          <Input
                            size="small"
                            allowClear
                            // disabled={
                            //   !(formState === "add" || formState === "edit")
                            // }
                            className="customInputs no-border-first"
                          />
                        </Form.Item>
                      </div>

                      <div className="customCols slc m-0 width400">
                        <Form.Item
                          label="Asn no"
                          labelCol={{ span: 10 }}
                          wrapperCol={{ span: 14 }}
                          name="asn_no"
                          rules={[
                            {
                              required: true,
                              message: "Asn no is required",
                            },
                          ]}
                        >
                          <Input
                            size="small"
                            allowClear
                            // disabled={
                            //   !(formState === "add" || formState === "edit")
                            // }
                            className="customInputs no-border-first"
                          />
                        </Form.Item>
                      </div>

                      <div className="customCols slc m-0 width400">
                        <Form.Item
                          label="To location"
                          name="to_location"
                          labelCol={{ span: 10 }}
                          wrapperCol={{ span: 14 }}
                          rules={[
                            {
                              required: true,
                              message: "To location is required",
                            },
                          ]}
                        >
                          <Select
                            size="small"
                            autoComplete={"nope"}
                            filterOption={(input, option) => option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                            filterSort={(optionA, optionB) =>
                              optionA.children.toLowerCase().localeCompare(optionB.children.toLowerCase())
                            }
                            showSearch
                            allowClear
                            loading={itemTransferFormData.loading}
                            // disabled={
                            //   !(formState === "add")
                            // }
                            defaultValue={form.getFieldValue().toLocation}

                          // onChange={(value) => handleChange(value)}
                          >
                            {itemTransferFormData?.payload?.location.map(
                              (item) => {
                                return (
                                  <Option
                                    key={item.location_id}
                                    value={item.location_id}
                                  >
                                    {item.location_name}
                                  </Option>
                                );
                              }
                            )}
                          </Select>
                        </Form.Item>
                      </div>
                      <div className="customCols slc m-0 width400">
                        <Button
                          style={{ marginLeft: 20 }}
                          onClick={() => formSave()}
                        >Generate</Button>
                      </div>

                    </div>
                  </Form>

                </div>
              </Col>
            </Row>
          </div>
        </div>

      </div>
    </div>
  );
};

export default CreateTransfer;
